import { dateFormatShortMonthDateYear12HourTime } from '@/helpers/formatting';

export default function formattedDate(date) {
  return dateFormatShortMonthDateYear12HourTime(new Date(date));
}
